<template>
    <ssam-talk-detail-link
         v-if="detailLayout != ''"
        :detailLayout="detailLayout"
        :ssam-talk-data="ssamTalkData"
    ></ssam-talk-detail-link>
</template>

<script>
import SsamtalkUtil from "@/components/ssamtalk/ssamtalkUtil";
import alertMixins from "@/mixins/alertMixins";
import SsamTalkDetailLink from "@/components/ssamtalk/link/SsamTalkDetailLink.vue";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";

export default {
    name: "SsamTalkDetailComponent",
    mixins: [SsamtalkUtil, alertMixins],
    components: {
        SsamTalkDetailLink
    },
    provide() {
        return {
            openFinishSaveConfirm: this.openFinishSaveConfirm,
            runDeleteConfirm: this.runDeleteConfirm,
        }
    },
    props: {
        ssamTalkType: {default: ""},
        ssamTalkKey: {default: 0},
    },
    data() {
        return {
            detailLayout: '',
            getFunc: '',
            detailApiParamSet: {},
            keyName: '',
            deleteAlertMsg: '정말 삭제하시겠습니까?',
            deleteFunc: "",
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            DeleteClass: null,
            deleteKeyName:'',
            ssamTalkData: {},
        }
    },
    created() {
        this.initConfig();
        this.getDetail();
    },
    mounted() {
        EventBus.$on('getDetail', this.getDetail)
    },
    beforeDestroy() {
        EventBus.$off('getDetail')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnSsamTalkConfig(this.ssamTalkType);
            this.detailLayout = config.detailLayout;
            this.getFunc = config.getFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.keyName = config.keyName;
            this.deleteAlertMsg = config.deleteAlertMsg ?? this.deleteAlertMsg;
            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.deleteKeyName = config.deleteKeyName;
            this.newDeleteClass();
        },
        getDetail() {
            let params = Object.assign({}, this.detailApiParamSet);
            params[this.keyName] = this.ssamTalkKey;
            EventBus.$emit("apiLoading", true);
            try {
                this.$api.$ssamtalk[this.getFunc](params).then((res) => res.Data.Result).then((res) => {
                    if (res.Info.type !== 1 || util.isEmpty(res.List)) {
                        this.errorAlert("데이터를 불러올 수 없습니다.");
                        this.$router.back();
                        return false;
                    }
                    if (res.List.hasOwnProperty('SsamTalk')) {
                        this.ssamTalkData = res.List.SsamTalk[0]
                    }
                    EventBus.$emit("apiLoading", false);
                });
            } catch (e) {
                console.log(e);
            }
        },
        openFinishSaveConfirm() {
            if(util.isEmpty(this.ssamTalkData.Step)) {
                this.errorAlert('STEP은 최소 1개 존재해야 합니다.');
                return;
            }
            this.createConfirm({
                content: '제출시 수정이 불가합니다. 최종 제출하시겠습니까?',
                confirmText: '최종제출',
                cancelText: '취소',
                confirm: () => {
                    this.runFinishSave();
                }
            })
        },
        runFinishSave() {
            let params = {s_idx: this.ssamTalkKey};
            EventBus.$emit('apiLoading', true);
            try {
                this.$api.$ssamtalk.finishSsamTalk(params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('apiLoading', false);
                    if(res.Info.type === 1) {
                        this.ssamTalkData = {};
                        this.detailLayout = '';
                        this.createAlert({
                            content: '최종제출 되었습니다.',
                            hide: () => {
                                this.initConfig();
                                this.getDetail();
                            }
                        })
                    }else {
                        this.errorAlert('최종제출에 실패하였습니다. 잠시후 다시 시도해주세요.')
                    }
                })
            }catch (e) {
                console.log(e);
            }
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$ssamtalk[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.deleteKeyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                };
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDeleteConfirm() {
            this.createConfirm({
                content: this.deleteAlertMsg,
                confirmText: "삭제",
                confirm: () => {
                    this.runDelete();
                },
            });
        },
        runDelete() {
            EventBus.$emit("apiLoading", true);
            this.DeleteClass.runDelete(this.ssamTalkKey);
        },
        deleteAfterFunc() {
            EventBus.$emit("apiLoading", false);
            this.createAlert({
                content: "삭제가 완료되었습니다.",
                hide: () => {
                    this.$router.back();
                },
            });
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
